import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '../../../core/services/translate.service';
import { NgClass } from '@angular/common';
import { MagneticDirective } from '../../directives/magnetic.directive';

type Lang = 'es' | 'en';

@Component({
  selector: 'app-language-toggle',
  standalone: true,
  imports: [MagneticDirective, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      appMagnetic
      [strength]="0.18"
      class="flex cursor-pointer items-center gap-1 rounded-lg border border-main p-0.5"
    >
      <button
        (click)="changeLang('es')"
        [attr.aria-label]="
          translate.currentLang() === 'es'
            ? translate.t('nav.lang_current') + ': Español'
            : translate.t('nav.lang_es')
        "
        [attr.title]="
          translate.currentLang() === 'es'
            ? translate.t('nav.lang_current') + ': Español'
            : translate.t('nav.lang_es')
        "
        class="cursor-pointer rounded-md px-2 py-1 text-xs font-medium transition-all"
        [ngClass]="
          translate.currentLang() === 'es'
            ? 'bg-surface-strong text-main'
            : 'text-dimmed hover:text-subtle'
        "
      >
        ES
      </button>
      <button
        (click)="changeLang('en')"
        [attr.aria-label]="
          translate.currentLang() === 'en'
            ? translate.t('nav.lang_current') + ': English'
            : translate.t('nav.lang_en')
        "
        [attr.title]="
          translate.currentLang() === 'en'
            ? translate.t('nav.lang_current') + ': English'
            : translate.t('nav.lang_en')
        "
        class="cursor-pointer rounded-md px-2 py-1 text-xs font-medium transition-all"
        [ngClass]="
          translate.currentLang() === 'en'
            ? 'bg-surface-strong text-main'
            : 'text-dimmed hover:text-subtle'
        "
      >
        EN
      </button>
    </div>
  `,
})
export class LanguageToggleComponent {
  protected readonly translate = inject(TranslateService);
  private readonly router = inject(Router);

  public changeLang(lang: Lang): void {
    if (this.translate.currentLang() === lang) {
      return;
    }

    this.translate.setLang(lang);

    // Swap the lang prefix in the current URL: /es/projects -> /en/projects
    const currentUrl = this.router.url;
    const newUrl = currentUrl.replace(/^\/(es|en)/, `/${lang}`);
    void this.router.navigateByUrl(newUrl);
  }
}
